//import { CallBackEndService } from '../service/call-back-end.service';

import { CallBackEndService } from '../call-back-end.service';
import { timerComponent } from "../cheque-book-request/timerComponent";
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
declare var getHexAscii: any;

@Component({
  selector: 'app-add-payee',
  templateUrl: './add-payee.component.html',
  styleUrls: ['./add-payee.component.css']
})
export class AddPayeeComponent implements OnInit {
  payeesucess: string;
  isDisabled: boolean = false;
  isShow: string = 'page1';
  isLoad: boolean = false;
  addOrModify: string = 'S';
  nickName: string;
  fullName: string;
  accountNo: string;
  ifscCode: string;
  mobileNo: string;
  mmid: string;
  aadharNo: string;
  otp: string;
  error: string = '';

  nicknameblank: string;
  fullnameblank: string;
  payeeIfscNotlank: string;
  IfscMobtNoblank: string;
  alltrue: string;
  payeeIfscmessageForSpace: string;
  payeeIfscmessageForacctspeci: string;
  payeeIfscmessageForacctLength: string;
  payeeIfscmessageForacctMinLength: string;
  payeeCheckZeroOnly: string;
  ifscCodeblank: string;
  ifscCodeNoSpace: string;
  ifscCodenotnospecial: string;
  ifscCodenotlength: string;
  ifscCheckZeroOnly: string;
  IfscMobNoSpace: string;
  IfscnotMobNumber: string;
  IfscnotMobspecial: string;
  IfscnotRange: string;
  MobileZeroOnly: string;
  mmidNoblank: string;
  mmidNoSpace: string;
  disabledaddpayeenext: boolean;
  mmidNumber: string;
  mmidZeroOnly: string;
  mmidnotRange: string;
  nicknameSpace: string;
  nicknameSpeci: string;
  nicknamelength: string;
  disabled: boolean;
  desabledsubmitpayee: boolean;
  fullnameSpeci: string;
  fullnamelength: string;
  fullnameNumbers: string;
  fullnameSpace: string;
  ifscCodeOnlyZeroes: string;
  mmidspecial: string;
  aadharNoblank: string;
  aadharNoSpace: string;
  aadharNumber: string;
  aadharspecial: string;
  aadharnotRange: string;
  aadharnotZeroOnly: string;
  OtpNotlank: string;

  reg = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regNum = /^[0-9]+$/;
  regchar = '/^[a-zA-Z]+$/';
  regexpspace = /\s+/;
  regZeroOnly = '^[0][0]*[0]$';
  regNumbers = /^.*[0-9]/;
  //regAlphaNumeric =  /^[a-z0-9]+$/i; [a-zA-Z0-9]
  regAlphaNumeric = '^[A-Za-z0-9]*$';
  regNumsOnly =/^\d+$/;
  regCharAndSpaceOnly =  /^[a-zA-Z\s]*$/; 
AccountNoLength:String;
  payeeBAckendErr: any;
  constructor(private webService: CallBackEndService,
             // private timetStart : timerComponent,
              private spinnerService: Ng4LoadingSpinnerService) {

  }

  ngOnInit() {
   
  }

  validateNickName() {
    this.error = '';
    // if (this.nickName.match(this.regAlphaNumeric)){
    //   console.log("cond true");
    //   if(this.nickName.match(this.regNumsOnly)){
    //  //only numbers are not allowed
    //  console.log('only numbers are not allowed');
    //   }else{
    // console.log('perfect alphanumeric');
    //   }
     
    // } else{
    //   console.log("cond fal");
     
    // }
    if (this.nickName === undefined || this.nickName === '' || this.nickName == null) {
      this.nicknameblank = 'no';
      this.disabledaddpayeenext = true;
    } 
    else if (this.nickName === ' ' || this.nickName.indexOf(' ') !== -1) {
      this.nicknameSpace = 'no';
      this.disabledaddpayeenext = true;
    }else if (!this.nickName.match(this.regAlphaNumeric)){
       this.nicknameSpeci='onlyAlphaNum';
       this.disabledaddpayeenext = true;
    }else if(this.nickName.match(this.regNumsOnly)){
      this.nicknameSpeci='notOnlyNum';
      this.disabledaddpayeenext = true;
    }
    //  else if (this.nickName === '' || this.nickName === undefined) {
    //   this.nicknameblank = 'no';
    //   this.disabledaddpayeenext = true;
    // } else if (this.nickName.match(this.reg)) {
    //   this.nicknameSpeci = 'no';
    //   this.disabledaddpayeenext = true;
    // } 
    else if (this.nickName.length > 10) {
      this.nicknamelength = 'no';
      this.disabledaddpayeenext = true;
    } else if (this.nickName) {
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.spinnerService.show();
      this.isLoad = true;
      request.param1 = getHexAscii('',sessionStorage.getItem('storedUserName') + this.nickName);
      request.param2 =sessionStorage.getItem('storedUserName');
      request.param3 = this.nickName;
      this.webService.getResponse(request, 'isNickNameExist').subscribe((data: IbResponse) => {
        response = data;
        this.spinnerService.hide();
        this.isLoad = false;
        // if (response !== null && response.param1 === 'Success') {
        //   if (response.status !== 'VALID_PAYEE_NAME') {
        //     if (response.status === 'PAYEE_EXIST_DELETED') {
        //       if (confirm(response.statusDescription) === true) {
        //         this.addOrModify = 'U';
        //       } else {
        //         this.nickName = '';
        //       }
        //     } else {
        //       alert(response.status);
        //       this.nickName = '';
        //     }
        //   }
        // }
        if(response.status==='S200'){
          this.nicknamelength = '';
          this.payeeBAckendErr = ''; 
        }
        else if(response.status==='PAYEE_EXIST'){
          this.nicknamelength = 'backendError';
          this.payeeBAckendErr = 'Beneficiary Nick Name Already Exist'; 
        }
         else if (response !== null) {
          this.error = response.statusDescription;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }

  validateIfscCode() {
    this.error = '';
    if (this.ifscCode === undefined || this.ifscCode === '') {
      this.ifscCodeblank = 'no';
      this.disabledaddpayeenext = true;
    } else if (this.ifscCode === ' ' || this.ifscCode.indexOf(' ') !== -1) {
      this.ifscCodeNoSpace = 'no';
      this.disabledaddpayeenext = true;
    } else if (this.ifscCode.match(this.reg)) {
      this.ifscCodenotnospecial = 'no';
      this.disabledaddpayeenext = true;
    } else if (this.ifscCode.length !=11) {
      this.ifscCodenotlength = 'no';
      this.disabledaddpayeenext = true;
    } else if (this.ifscCode.match(this.regZeroOnly)) {
      this.ifscCheckZeroOnly = 'no';
      this.disabledaddpayeenext = true;
    } else if (this.ifscCode) {
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 = getHexAscii('', this.ifscCode);
      request.param2 = this.ifscCode;
      this.spinnerService.show();
      this.webService.getResponse(request, 'isValidIfscCode').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        response = data;
        this.isLoad = false;
        if (response !== null && response.status === 'OBJECT_NOT_FOUND') {
          alert(response.param1);
          this.ifscCode = '';
        } else if (response !== null) {
          if (response.status !== 'S200') {
            this.error = response.statusDescription;
          }
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }

  getOtp() {
   // this.timetStart.resetTimer();
    this.isDisabled =true;
    this.error = '';
    if (this.nickName === undefined || this.nickName === '') {
      this.nicknameblank = 'no';
      this.isDisabled =false;
      this.alltrue = 'false';
    } else if (this.fullName === undefined || this.fullName === '') {
      this.fullnameblank = 'no';
      this.alltrue = 'false';
      this.isDisabled =false;
    } else if ((this.ifscCode !== undefined && this.ifscCode !== '') && (this.accountNo === undefined || this.accountNo === '')) {
      this.payeeIfscNotlank = 'no';
      this.alltrue = 'false';
      this.isDisabled =false;
    } else if ((this.mmid !== undefined && this.mmid !== '') && (this.mobileNo === undefined || this.mobileNo === '')) {
      this.IfscMobtNoblank = 'no';
      this.alltrue = 'false';
      this.isDisabled =false;
    } else if ((this.accountNo === undefined || this.accountNo === '') && (this.mobileNo === undefined || this.mobileNo === '')) {
      this.alltrue = 'false';
      alert('Please Enter Account Number and IFSC Code Or Mobile Number And MMID Or Aadhar Number');
      this.isDisabled =false;
    } else if ((this.accountNo !== undefined || this.accountNo !== '') && (this.mobileNo === undefined || this.mobileNo === '')) {
      if (this.accountNo.match(this.regexpspace)) {
        this.payeeIfscmessageForSpace = 'no';
        //this.disabledaddpayeenext=true;
        this.alltrue = 'false';
        this.isDisabled =false;

      } else if (this.accountNo.match(this.reg)) {
        this.payeeIfscmessageForacctspeci = 'no';
        //this.disabledaddpayeenext=true;
        this.alltrue = 'false';
        this.isDisabled =false;
      } else if (this.accountNo.length > 18) {
        this.payeeIfscmessageForacctLength = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.accountNo.length < 9) {
        this.payeeIfscmessageForacctMinLength = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //  this.disabledaddpayeenext=true;

      } else if (this.accountNo.match(this.regZeroOnly)) {
        this.payeeCheckZeroOnly = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;

      } else if (this.ifscCode === undefined || this.ifscCode === '') {
        this.ifscCodeblank = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.ifscCode === ' ' || this.ifscCode.indexOf(' ') !== -1) {
        this.ifscCodeNoSpace = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.ifscCode.match(this.reg)) {
        this.ifscCodenotnospecial = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.ifscCode.length > 11||this.ifscCode.length <11) {
        this.ifscCodenotlength = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.ifscCode.match(this.regZeroOnly)) {
        this.ifscCheckZeroOnly = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //  this.disabledaddpayeenext=true;


      }
    } else if ((this.accountNo === undefined || this.accountNo === '') && (this.mobileNo !== undefined || this.mobileNo !== '')) {

      if (this.mobileNo === ' ' || this.mobileNo.indexOf(' ') !== -1) {
        this.IfscMobNoSpace = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (!this.mobileNo.match(this.regNum)) {
        this.IfscnotMobNumber = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.mobileNo.match(this.reg)) {
        this.IfscnotMobspecial = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.mobileNo.trim().length !== 10) {
        this.IfscnotRange = 'no';
        this.alltrue = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.mobileNo.match(this.regZeroOnly)) {
        this.MobileZeroOnly = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.mmid === undefined || this.mmid === '') {
        this.mmidNoblank = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.mmid === ' ' || this.mmid.indexOf(' ') !== -1) {
        this.mmidNoSpace = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext = true;
      } else if (!this.mmid.match(this.regNum)) {
        this.mmidNumber = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (!this.mmid.match(this.regNum)) {
        this.mmidNumber = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.mmid.match(this.regZeroOnly)) {
        this.mmidZeroOnly = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.mmid.trim().length !== 7) {
        this.mmidnotRange = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      }
    } else if ((this.accountNo !== undefined || this.accountNo !== '') && (this.mobileNo !== undefined || this.mobileNo !== '')) {
      if (this.accountNo.match(this.regexpspace)) {
        this.payeeIfscmessageForSpace = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;

      } else if (this.accountNo.match(this.reg)) {
        this.payeeIfscmessageForacctspeci = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.accountNo.length > 18) {
        this.payeeIfscmessageForacctLength = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.accountNo.length < 9) {
        this.payeeIfscmessageForacctMinLength = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //  this.disabledaddpayeenext=true;

      } else if (this.accountNo.match(this.regZeroOnly)) {
        this.payeeCheckZeroOnly = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;

      } else if (this.ifscCode === undefined || this.ifscCode === '') {
        this.ifscCodeblank = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.ifscCode === ' ' || this.ifscCode.indexOf(' ') !== -1) {
        this.ifscCodeNoSpace = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.ifscCode.match(this.reg)) {
        this.ifscCodenotnospecial = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.ifscCode.length > 11||this.ifscCode.length <11) {
        this.ifscCodenotlength = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.ifscCode.match(this.regZeroOnly)) {
        this.ifscCheckZeroOnly = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;

      } else if (this.mobileNo === ' ' || this.mobileNo.indexOf(' ') !== -1) {
        this.IfscMobNoSpace = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (!this.mobileNo.match(this.regNum)) {
        this.IfscnotMobNumber = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.mobileNo.match(this.reg)) {
        this.IfscnotMobspecial = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.mobileNo.trim().length !== 10) {
        this.IfscnotRange = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.mobileNo.match(this.regZeroOnly)) {
        this.MobileZeroOnly = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      }
      //MMID
      if (this.mmid === undefined || this.mmid === '') {
        this.mmidNoblank = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.mmid === ' ' || this.mmid.indexOf(' ') !== -1) {
        this.mmidNoSpace = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (!this.mmid.match(this.regNum)) {
        this.mmidNumber = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.mmid.match(this.reg)) {
        this.mmidspecial = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.mmid.trim().length !== 7) {
        this.mmidnotRange = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.mmid.match(this.regZeroOnly)) {
        this.mmidZeroOnly = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      }
    }

    if (this.nickName && this.fullName && this.alltrue === 'true') {
      this.disabledaddpayeenext = true;
      this.desabledsubmitpayee = false;
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      this.spinnerService.show();
      request.param1 = getHexAscii('',sessionStorage.getItem('storedUserName'));
      request.param2 =sessionStorage.getItem('storedUserName');
      this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        response = data;
        this.isLoad = false;
        if (response !== null && response.status === 'S200') {
          //console.log('Otp :' + response.param1);
          this.isShow = 'page2';
        } else if (response !== null) {
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
    this.otp = '';
  }

  addPayeeRequest() {
   // this.timetStart.resetTimer();
    this.error = '';
    if (this.nickName && this.fullName && ((this.accountNo && this.ifscCode) || (this.mmid && this.mobileNo) || (this.aadharNo)) && this.otp.length==6) {
      this.desabledsubmitpayee = true;
      this.disabledaddpayeenext = false;
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.spinnerService.show();
      this.isLoad = true;
      let accountNo: string = '';
      let ifscCode: string = '';
      let mobileNo: string = '';
      let mmid: string = '';
      let aadharNo: string = '';
      if (this.mobileNo){
        mobileNo = this.mobileNo;}
      if (this.mmid){
        mmid = this.mmid;}
      if (this.accountNo){
        accountNo = this.accountNo;}
      if (this.ifscCode){
        ifscCode = this.ifscCode;}
      if (this.aadharNo){
        aadharNo = this.aadharNo;}
      const payeeInfo: any = {
        'userName':sessionStorage.getItem('storedUserName'),
        'nickName': this.nickName,
        'fullName': this.fullName.trim(),
        'acctNo': accountNo,
        'ifscCd': ifscCode,
        'mobileNo': mobileNo,
        'mmid': mmid,
        'aadharNo': aadharNo,
        'addOrModify': this.addOrModify
      };
      request.param1 = getHexAscii('', this.otp +sessionStorage.getItem('storedUserName') + this.nickName + this.fullName.trim() + accountNo + ifscCode + mobileNo + mmid + aadharNo + this.addOrModify);
      request.param2 = getHexAscii('',this.otp);
      request.param6 = payeeInfo;
      this.webService.getResponse(request, 'addOrModifyPayee').subscribe((data: IbResponse) => {
        response = data;
        this.spinnerService.hide();
        this.isLoad = false;
        if (response !== null && response.status === 'S200') {
          this.payeesucess = response.param1;
          this.isShow = 'page3';
          // alert(response.param1);

        } else if (response !== null) {
          this.error = response.param1;
         
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }

  changeGetpayeeOTPValid(){
    console.log('onClick otp called..........');
    this.desabledsubmitpayee = false;
    this.OtpNotlank='onCLk';
    this.error='';
  }


  back() {
    //this.timetStart.resetTimer();
    this.disabled = false;
    this.isDisabled=false;
    this.disabledaddpayeenext = false;
    this.desabledsubmitpayee = false;
    this.alltrue = 'true';
    this.isShow = 'page1';
    this.isLoad = false;
    this.otp = '';
    this.error = '';
  }

  removePayeeNameMessage() {
    this.nicknameSpeci = '';
    this.nicknameSpace = '';
    this.nicknameblank = '';
    this.nicknamelength = '';
    this.disabledaddpayeenext = false;
    this.alltrue = 'true';

  }

  validateFullName() {
    if (this.fullName === undefined) {
      this.fullnameblank = 'no';
      this.disabledaddpayeenext = true;
    } else if (this.fullName === '' || this.fullName === undefined) {
      this.fullnameblank = 'no';
      this.disabledaddpayeenext = true;
    } else if (this.fullName.match(this.reg)) {
      this.fullnameSpeci = 'no';
      this.disabledaddpayeenext = true;
    } else if (this.fullName.length > 50) {
      this.fullnamelength = 'no';
      this.disabledaddpayeenext = true;
    } else if (this.fullName.match(this.regNumbers)) {
      this.fullnameNumbers = 'no';
      this.disabledaddpayeenext = true;
    }
  }

  removeFullNameMessage() {
    this.fullnameSpace = '';
    this.fullnameblank = '';
    this.fullnameSpeci = '';
    this.fullnamelength = '';
    this.fullnameNumbers = '';
    this.disabledaddpayeenext = false;
    this.alltrue = 'true';
  }

  getIfscRemove() {
    this.ifscCodeblank = '';
    this.ifscCodeNoSpace = '';
    this.ifscCodenotnospecial = '';
    this.ifscCodenotlength = '';
    this.ifscCodeOnlyZeroes = '';
    this.ifscCheckZeroOnly = '';
    this.payeeIfscNotlank = '';
    this.payeeIfscmessageForSpace = '';
    this.payeeIfscmessageForacctspeci = '';
    this.payeeIfscmessageForacctLength = '';
    this.payeeIfscmessageForacctMinLength = '';
    this.payeeCheckZeroOnly = '';
    this.disabledaddpayeenext = false;
    this.alltrue = 'true';
  }

  getIfscmobileValid() {

    if (this.mobileNo === undefined || this.mobileNo === '') {
      this.IfscMobtNoblank = 'no';
      this.disabledaddpayeenext = true;
    } else if (this.mobileNo === ' ' || this.mobileNo.indexOf(' ') !== -1) {
      this.IfscMobNoSpace = 'no';
      this.disabledaddpayeenext = true;
    }else if (this.mobileNo.match(this.reg)) {
      this.IfscnotMobspecial = 'no';
      this.disabledaddpayeenext = true;
    } else if (!this.mobileNo.match(this.regNum)) {
      this.IfscnotMobNumber = 'no';
      this.disabledaddpayeenext = true;
    }  else if (this.mobileNo.trim().length !== 10) {
      this.IfscnotRange = 'no';
      this.disabledaddpayeenext = true;
    }
  }

  removeIfscmobileMessage() {
    this.IfscMobtNoblank = '';
    this.IfscMobNoSpace = '';
    this.IfscnotMobNumber = '';
    this.IfscnotMobspecial = '';
    this.IfscnotRange = '';
    this.MobileZeroOnly = '';
    this.disabledaddpayeenext = false;
    this.alltrue = 'true';

  }

  getMMIDValid() {
    if (this.mmid === undefined || this.mmid === '') {
      this.mmidNoblank = 'no';
      this.disabledaddpayeenext = true;
    } else if (this.mmid === ' ' || this.mmid.indexOf(' ') !== -1) {
      this.mmidNoSpace = 'no';
      this.disabledaddpayeenext = true;
    } else if (this.mmid.match(this.reg)) {
      this.mmidspecial = 'no';
      this.disabledaddpayeenext = true;
    } else if (!this.mmid.match(this.regNum)) {
      this.mmidNumber = 'no';
      this.disabledaddpayeenext = true;
    } else if (this.mmid.trim().length !== 7) {
      this.mmidnotRange = 'no';
      this.disabledaddpayeenext = true;
    }
  }

  removeMMIDMessage() {
    this.mmidNoblank = '';
    this.mmidNoSpace = '';
    this.mmidNumber = '';
    this.mmidspecial = '';
    this.mmidnotRange = '';
    this.mmidZeroOnly = '';
    this.IfscMobtNoblank = '';
    this.IfscMobNoSpace = '';
    this.IfscnotMobNumber = '';
    this.IfscnotMobspecial = '';
    this.IfscnotRange = '';
    this.MobileZeroOnly = '';
    this.disabledaddpayeenext = false;
    this.alltrue = 'true';
  }

  getAdharValid() {
    if (this.aadharNo === undefined || this.aadharNo === '') {
      this.aadharNoblank = 'no';
      this.disabledaddpayeenext = true;
    } else if (this.aadharNo === ' ' || this.aadharNo.indexOf(' ') !== -1) {
      this.aadharNoSpace = 'no';
      this.disabledaddpayeenext = true;
    } else if (!this.aadharNo.match(this.regNum)) {
      this.aadharNumber = 'no';
      this.disabledaddpayeenext = true;
    } else if (this.aadharNo.match(this.reg)) {
      this.aadharspecial = 'no';
      this.disabledaddpayeenext = true;
    } else if (this.aadharNo.trim().length !== 12) {
      this.aadharnotRange = 'no';
      this.disabledaddpayeenext = true;
    }
  }

  removeAdharMessage() {

    this.aadharNoblank = '';
    this.aadharNoSpace = '';
    this.aadharNumber = '';
    this.aadharspecial = '';
    this.aadharnotRange = '';
    this.aadharnotZeroOnly = '';
    this.disabledaddpayeenext = false;
    this.alltrue = 'true';
    this.disabled = false;
  }

  getpayeeOTPValid() {
    if (this.otp === undefined || this.otp === '') {
      this.OtpNotlank = 'no';
      this.disabledaddpayeenext = true;
    }else if (this.otp.match(this.reg)) {
      this.OtpNotlank = 'specialChar';
      this.disabledaddpayeenext = true;
    }else if (!this.otp.match(this.regNum)) {
      this.OtpNotlank = 'num';
      this.disabledaddpayeenext = true;
    } else if (this.otp.length!=6) {
      this.OtpNotlank = 'len';
      this.disabledaddpayeenext = true;
    }else{
      this.OtpNotlank = '';
      this.disabledaddpayeenext = false;
    }
  }

  otp1() {
    this.OtpNotlank = '';
    this.disabledaddpayeenext = true;
  }

  removePayeeAcctMessage() {
    this.payeeIfscNotlank = '';
    this.payeeIfscmessageForSpace = '';
    this.payeeIfscmessageForacctspeci = '';
    this.payeeIfscmessageForacctLength = '';
    this.payeeIfscmessageForacctMinLength = '';
    this.payeeCheckZeroOnly = '';
    this.disabledaddpayeenext = false;
    this.alltrue = 'true';
  }

  validateAccNo()
  {
    if(this.accountNo==null || this.accountNo==undefined || this.accountNo===''){
        this.payeeIfscNotlank='no';
        this.alltrue = 'false';
        this.isDisabled =false;
    }
	 else if (this.accountNo.match(this.regexpspace)) {
        this.payeeIfscmessageForSpace = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;

      } else if (this.accountNo.match(this.reg)) {
        this.payeeIfscmessageForacctspeci = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.accountNo.length > 18) {
        this.payeeIfscmessageForacctLength = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;
      } else if (this.accountNo.length < 9) {
        this.payeeIfscmessageForacctMinLength = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //  this.disabledaddpayeenext=true;

      } else if (this.accountNo.match(this.regZeroOnly)) {
        this.payeeCheckZeroOnly = 'no';
        this.alltrue = 'false';
        this.isDisabled =false;
        //this.disabledaddpayeenext=true;

      }
  }

  validateAdharAndAcctMob() {

    if (this.aadharNo !== undefined && this.aadharNo !== '') {

      if (this.aadharNo === ' ' || this.aadharNo.indexOf(' ') !== -1) {
        this.aadharNoSpace = 'no';
        this.disabledaddpayeenext = true;
      } else if (!this.aadharNo.match(this.regNum)) {
        this.aadharNumber = 'no';
        this.disabledaddpayeenext = true;
        this.disabled = true;
      } else if (this.aadharNo.match(this.reg)) {
        this.aadharspecial = 'no';
        this.disabledaddpayeenext = true;
        this.disabled = true;
      } else if (this.aadharNo.trim().length !== 12) {
        this.aadharnotRange = 'no';
        this.disabledaddpayeenext = true;
        this.disabled = true;
      } else if (this.aadharNo.match(this.regZeroOnly)) {
        this.aadharnotZeroOnly = 'no';
        this.disabledaddpayeenext = true;
        this.disabled = true;
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/add-payee/add-payee.component.ts